(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@justeat/f-button"));
	else if(typeof define === 'function' && define.amd)
		define(["@justeat/f-button"], factory);
	else if(typeof exports === 'object')
		exports["f-alert"] = factory(require("@justeat/f-button"));
	else
		root["f-alert"] = factory(root["@justeat/f-button"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_b560__) {
return 